import * as React from 'react';

const DisLogo: React.FC = () => (
  <svg
    width="160px"
    height="36px"
    viewBox="0 0 160 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-41.000000, -37.000000)" fill="#FFFFFF">
        <g transform="translate(41.000000, 37.000000)">
          <path d="M0,35.7647059 L20.6490144,35.7647059 C31.5169864,34.3470605 33.8823529,27.2591034 33.8823529,17.767436 C33.8823529,6.18011414 28.7679431,1.98896724 20.6490144,0.941176471 L0,0.941176471 L0,35.7647059 Z M9.46147949,7.04299177 L15.2789966,7.04299177 C24.6764946,7.04299177 24.8683992,13.2680713 24.8683992,18.1372272 C24.8683992,23.992502 24.4208867,29.7861224 15.2789966,29.7861224 C13.6168829,29.7861224 9.46147949,29.7861224 9.46147949,29.7861224 L9.46147949,7.04299177 Z" />
          <polygon
            fillRule="nonzero"
            points="41.4117647 35.7647059 50.8235294 35.7647059 50.8235294 0.941176471 41.4117647 0.941176471"
          />
          <path
            d="M103.732863,26.8893122 L121.463456,26.8893122 L125.35401,35.7647059 L129.882353,35.7647059 L114.766603,0.941176471 L110.174573,0.941176471 L95.0588235,35.7647059 L99.6509852,35.7647059 L103.732863,26.8893122 Z M119.868917,23.3760933 L105.263583,23.3760933 L112.661912,5.62540035 L119.868917,23.3760933 Z"
            fillRule="nonzero"
          />
          <path
            d="M59.5242279,34.2518588 C62.6475694,35.2200227 65.9661029,35.7647059 69.2195275,35.7647059 C77.0277465,35.7647059 84.7058824,33.3440976 84.7058824,24.3878205 C84.7058824,11.9215686 68.0482407,15.6735512 68.0482407,10.0455906 C68.0482407,7.01980375 71.9523502,6.83826475 74.3598979,6.83826475 C77.0277465,6.83826475 80.4113889,7.32238641 82.8189365,8.41166013 L82.8189365,1.27082729 C80.4113889,0.484124305 77.0928554,0 73.709213,0 C66.681762,0 58.3529412,2.29959111 58.3529412,10.5902208 C58.3529412,23.1775163 75.0105828,19.1228584 75.0105828,25.5375895 C75.0105828,28.3212758 72.2126511,28.9264941 69.2195275,28.9264941 C65.315418,28.9264941 61.9317756,27.9581978 59.5242279,26.6268235 L59.5242279,34.2518588 Z"
            fillRule="nonzero"
          />
          <path
            d="M149.055183,32.3807869 C151.581426,32.3807869 155.466715,32.4421976 155.466715,32.4421976 L155.466715,22.0443938 L150.544365,22.0443938 L150.544365,18.5990641 L160,18.5990641 L160,22.0443938 L160,35.7647059 L149.379851,35.7647059 C137.269179,35.7647059 131.764706,30.534964 131.764706,18.414428 C131.764706,5.80169051 137.399315,0.941176471 149.444248,0.941176471 C153.459673,0.941176471 156.8915,0.941176471 159.22321,0.941176471 L159.22321,4.38660447 L149.055183,4.38660447 C138.888497,4.38660447 137.140385,11.7696808 137.140385,18.414428 C137.074646,24.9360844 139.083029,32.3807869 149.055183,32.3807869 Z"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default DisLogo;
